const cache = {};
const generateKey = (fetchConfig) => {
    return `${fetchConfig.url}~${fetchConfig.options.method}`;
};
export const storeInCache = (fetchConfig, responseData) => {
    const key = generateKey(fetchConfig);
    cache[key] = responseData;
};
export const getFromCache = (fetchConfig) => {
    const key = generateKey(fetchConfig);

    return cache[key];
};
export const deleteFromCache = (fetchConfig) => {
    const key = generateKey(fetchConfig);
    delete cache[key];
};
